"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

require("../../assets/css/components/card/CardList.css");

var _Form = require("../form/Form");

var _Form2 = _interopRequireDefault(_Form);

var _CardSimples = require("./CardSimples");

var _CardSimples2 = _interopRequireDefault(_CardSimples);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CardList = function (_React$Component) {
    _inherits(CardList, _React$Component);

    function CardList() {
        _classCallCheck(this, CardList);

        return _possibleConstructorReturn(this, (CardList.__proto__ || Object.getPrototypeOf(CardList)).apply(this, arguments));
    }

    _createClass(CardList, [{
        key: "hasDescription",
        value: function hasDescription() {
            if (this.props.descricao) return _react2.default.createElement(
                "small",
                { "aria-hidden": this.props.hiddenDescription },
                this.props.descricao
            );
        }
    }, {
        key: "hasTools",
        value: function hasTools() {
            if (this.props.tools) {
                return this.props.tools;
            }
        }
    }, {
        key: "getContent",
        value: function getContent() {
            if (this.props.form) return _react2.default.createElement(
                _Form2.default,
                { onSubmit: this.props.onSubmit },
                this.props.children
            );else return this.props.children;
        }
    }, {
        key: "hasAction",
        value: function hasAction() {
            var hiddenTools = this.props.hiddenTools ? false : true;
            if (this.props.actions) return _react2.default.createElement(
                "div",
                { "aria-hidden": hiddenTools, className: "mdl-card__actions mdl-card--border " + (this.props.hiddenTools ? 'hiddenTools' : '') },
                this.props.actions
            );
        }
    }, {
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "div",
                { className: "mtd-card-list mdl-cell mdl-cell--" + (this.props.width ? this.props.width : 12) + "-col mdl-cell--8-col mdl-cell--8-col-tablet mdl-cell--10-col-phone " + (this.props.centered ? "mdl-cell--middle" : "") + " " + (this.props.className || "") },
                _react2.default.createElement(
                    "div",
                    { className: "mtd-cardlist-header" + (this.props.tools ? " mdl-card--tools " : "") },
                    _react2.default.createElement(
                        "h2",
                        { className: "mdl-card__title-text" },
                        this.props.titulo
                    ),
                    this.hasDescription(),
                    _react2.default.createElement(
                        "div",
                        { className: "mdl-card__menu" },
                        this.hasTools()
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "mtd-cardlist-body" },
                    this.getContent()
                ),
                this.hasAction()
            );
        }
    }]);

    return CardList;
}(_react2.default.Component);

exports.default = CardList;


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/card/CardList.js
// module id = 1106
// module chunks = 0